import React, {useState} from 'react';
import {AlertCircle, CheckCircle, Eye, FileText, Upload} from 'lucide-react';
import RenderIf from "@/components/render-if";
import TextToHTML from "@/components/text-to-html";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import UploadCMP from "@/components/upload";
import {useApiCreateStudentEquivalent} from "@/api/equivalent";
import {formatDate} from "@/lib/helper/date";
import FileViewer from "@/lib/helper/FileViewer";
import {Modal} from "antd";


function LessonRequirementSection({lessonDetail, refetch}) {


    const [uploadedDocuments, setUploadedDocuments] = useState({});
    const [expandedPreview, setExpandedPreview] = useState(null);
    const [loading, setLoading] = useState(false)

    const {mutate: sendEquivalent, isPending: isPendingEquivalent} = useApiCreateStudentEquivalent()

    const getStatusIcon = (status) => {
        switch (status) {
            case 'verified':
                return <CheckCircle className="w-4 h-4 text-green-500"/>;
            case 'rejected':
                return <AlertCircle className="w-4 h-4 text-red-500"/>;
            default:
                return <Upload className="w-4 h-4 text-blue-500"/>;
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'verified':
                return 'تأیید شده';
            case 'rejected':
                return 'رد شده';
            default:
                return 'در انتظار بررسی';
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'verified':
                return 'bg-green-50 text-green-700 border-green-200';
            case 'rejected':
                return 'bg-red-50 text-red-700 border-red-200';
            default:
                return 'bg-blue-50 text-blue-700 border-blue-200';
        }
    };


    function updatePrerequisiteFile(type, topicId, file) {
        let update = {}
        update['type'] = type;
        update['topic_id'] = topicId;
        update['file_id'] = file;

        setLoading(true);
        sendEquivalent(update, {
            onSuccess: (res) => {

                ApiHandleSuccessMessage(res);
                refetch()
                setLoading(false);
            },
            onError: (errors) => {
                ApiHandleErrorMessage(errors);
                setLoading(false);
            },
        });
    }

    const PrerequisiteCard = ({item, type}) => (
        <div className=" rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                        <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                            type === 'requirement'
                                ? 'bg-red-100 text-red-700'
                                : 'bg-orange-100 text-orange-700'
                        }`}>
                            {type === 'requirement' ? 'پیش‌نیاز' : 'هم‌نیاز'}
                        </div>
                    </div>
                    <h3 className="text-lg font-semibold  mb-2">
                        {item.parent_topic.title}
                    </h3>

                    <RenderIf condition={item?.parent_topic?.signupmsg}>
                        <div>
                            <TextToHTML>{item?.parent_topic?.signupmsg}</TextToHTML>
                        </div>
                    </RenderIf>


                </div>
            </div>

            {/* Upload Section */}
            <div className="border-t pt-4">
                <div className="flex items-center justify-between mb-3">
                    <h4 className="font-medium ">

                    </h4>

                    <span className="text-sm ">

            </span>

                </div>
                <RenderIf condition={item?.pass === false}>
                    {/* File Upload Area */}
                    <div className="mb-4">
                        <label className="block">
                            <RenderIf condition={item?.parent_topic?.signupdetail?.audio}>
                                <UploadCMP accept={'audio/*'} dragMode={true} label={'فایل صوتی'}
                                           afterUploadFn={(a) => {
                                               updatePrerequisiteFile('audio', item?.parent_topic_id, a?.file?.response?.data?.id)
                                           }}>
                                    <div className="flex flex-col items-center gap-2">
                                        <Upload className="w-6 h-6 "/>
                                        <p className="text-sm  text-center">
                                            <span className="font-medium text-blue-600">برای آپلود کلیک کنید</span>
                                            <br/>
                                            یا فایل را اینجا رها کنید
                                        </p>
                                        <p className="text-xs ">

                                        </p>
                                    </div>
                                </UploadCMP>
                            </RenderIf>
                            <RenderIf condition={item?.parent_topic?.signupdetail?.pdf}>
                                <UploadCMP accept={'.pdf'} dragMode={true} label={'فایل pdf'} afterUploadFn={(a) => {
                                    updatePrerequisiteFile('pdf', item?.parent_topic_id, a?.file?.response?.data?.id)
                                }}>
                                    <div className="flex flex-col items-center gap-2">
                                        <Upload className="w-6 h-6 "/>
                                        <p className="text-sm  text-center">
                                            <span className="font-medium text-blue-600">برای آپلود کلیک کنید</span>
                                            <br/>
                                            یا فایل را اینجا رها کنید
                                        </p>
                                        <p className="text-xs ">
                                            فایل با فرمت pdf
                                        </p>
                                    </div>
                                </UploadCMP>
                            </RenderIf>
                            <RenderIf condition={item?.parent_topic?.signupdetail?.image}>
                                <UploadCMP accept={'image/*'} dragMode={true} label={'فایل تصویری'}
                                           afterUploadFn={(a) => {
                                               updatePrerequisiteFile('jpg', item?.parent_topic_id, a?.file?.response?.data?.id)
                                           }}>
                                    <div className="flex flex-col items-center gap-2">
                                        <Upload className="w-6 h-6 "/>
                                        <p className="text-sm  text-center">
                                            <span className="font-medium text-blue-600">برای آپلود کلیک کنید</span>
                                            <br/>
                                            یا فایل را اینجا رها کنید
                                        </p>
                                        <p className="text-xs ">
                                            فایل با فرمت jpg, bmp, jpeg
                                        </p>
                                    </div>
                                </UploadCMP>
                            </RenderIf>

                        </label>
                    </div>
                </RenderIf>


                <RenderIf condition={item?.equivalents?.length > 0}>
                    {item.equivalents.map((equivalent, index) => (
                        <>
                            {/* Uploaded Files */}
                            <div className="space-y-2 mb-2">

                                <div
                                    key={'item-equivalent' + item.id + '_'.index + '_'.item?.topic_id + '-'.item?.parent_topic_id}
                                    className={`flex items-center gap-3 p-3 rounded-lg border ${getStatusColor(equivalent.status)}`}
                                >
                                    <div className="flex-shrink-0">
                                        {getStatusIcon(equivalent.status)}
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2">
                                            <FileText className="w-4 h-4  flex-shrink-0"/>
                                            <span className="text-sm font-medium  truncate">
                                                <RenderIf condition={equivalent.pdf}>فایل pdf</RenderIf>
                                                <RenderIf condition={equivalent.audio}>فایل صوتی</RenderIf>
                                                <RenderIf condition={equivalent.jpg}>فایل تصویری</RenderIf>
                    </span>
                                        </div>
                                        <div className="flex items-center gap-2 mt-1">
                    <span className="text-xs ">
                      {formatDate(equivalent.datecreated)}
                    </span>
                                            <span className="text-xs">•</span>
                                            <span className={`text-xs font-medium ${
                                                'uploadedFile.status' === 'verified' ? 'text-green-600' :
                                                    'uploadedFile.status' === 'rejected' ? 'text-red-600' : 'text-blue-600'
                                            }`}>
                      {getStatusText(equivalent.status)}
                    </span>
                                        </div>
                                        <RenderIf condition={equivalent.desc}>
                                            <p>{equivalent.desc}</p>
                                        </RenderIf>
                                        <div>

                                        </div>
                                    </div>

                                    <div className="flex items-center gap-1">

                                        <button
                                            onClick={() => setExpandedPreview(equivalent)}
                                            className="p-1  hover:text-blue-600 hover:bg-blue-50 rounded"
                                            title="پیش‌نمایش"
                                        >
                                            <Eye className="w-4 h-4"/>
                                        </button>


                                    </div>
                                </div>

                            </div>
                        </>
                    ))}
                </RenderIf>

                <RenderIf condition={type === 'requirement'}>
                    <RenderIf condition={item?.pass === true}>
                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                            <p className="text-xs text-green-800">
                                <CheckCircle className="w-3 h-3 inline ml-1"/>
                                شما این پیش‌نیاز درس را با موفقیت گذرانده اید.
                            </p>
                        </div>
                    </RenderIf>
                    <RenderIf condition={item?.pass === false}>
                        <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                            <p className="text-xs text-amber-800">
                                <AlertCircle className="w-3 h-3 inline ml-1"/>
                                توجه: بدون تأیید این مدرک، امکان ثبت‌نام در کلاس وجود ندارد.
                            </p>
                        </div>
                    </RenderIf>
                </RenderIf>

                <RenderIf condition={type === 'beside'}>
                    <RenderIf condition={item?.take_in_this_semester === true}>
                        <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
                            <p className="text-xs text-green-800">
                                <CheckCircle className="w-3 h-3 inline ml-1"/>
                                شما در ترم جاری این درس را انتخاب کرده اید.
                            </p>
                        </div>
                    </RenderIf>

                    <RenderIf condition={item?.take_in_this_semester === false}>
                        <div className="mt-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                            <p className="text-xs text-amber-800">
                                <AlertCircle className="w-3 h-3 inline ml-1"/>
                                شما باید در همین ترم این درس هم‌نیاز را انتخاب کرده باشید.
                            </p>
                        </div>
                    </RenderIf>


                </RenderIf>

            </div>
        </div>
    );

    if (!lessonDetail?.prerequisite_list) return null;
    if (lessonDetail?.prerequisite_list?.requirement?.length === 0 && lessonDetail?.prerequisite_list?.beside_requirement?.length === 0) {
        return null;
    }

    return (
        <>
            <Modal
                title="پیش نمایش فایل"
                footer={[]}
                open={expandedPreview}
                onCancel={() => setExpandedPreview(null)}


            >
                <FileViewer fileUrl={expandedPreview?.audio ?? expandedPreview?.jpg ?? expandedPreview?.pdf}/>
            </Modal>
            <div className=" rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
                    <h2 className="text-xl font-bold text-white flex items-center gap-2">
                        <FileText className="w-6 h-6"/>
                        بررسی پیش‌نیازها و هم‌نیازها
                    </h2>
                    <p className="text-blue-100 text-sm mt-1">
                        لطفاً مدارک گذراندن درس‌های قبلی خود را آپلود کنید
                    </p>
                </div>

                <div className="p-6">
                    {/* Prerequisites */}
                    {lessonDetail?.prerequisite_list?.requirement?.length > 0 && (
                        <div className="mb-8">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-4 h-4 bg-red-500 rounded-full"></div>
                                <h3 className="text-lg font-semibold ">
                                    پیش‌نیازها
                                </h3>


                            </div>
                            <p className="text-sm  mb-2">

                                برای شرکت در این درس باید باید قبلا پیش‌نیاز‌های این درس را گذرانده باشید.
                                <br/>
                                برای صحت سنجی گذراندن این پیش نیاز‌ها لطفا موارد درخواست شده را ارسال نمایید

                            </p>

                            <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-2">
                                {lessonDetail?.prerequisite_list?.requirement.map((item) => (
                                    <PrerequisiteCard key={item.id} item={item} type="requirement"/>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Co-requisites */}
                    {lessonDetail?.prerequisite_list?.beside_requirement?.length > 0 && (
                        <div>
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-4 h-4 bg-orange-500 rounded-full"></div>
                                <h3 className="text-lg font-semibold ">
                                    هم‌نیازها
                                </h3>
                                <span
                                    className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full text-xs font-medium">
                  {lessonDetail?.prerequisite_list?.beside_requirement?.length} درس
                </span>
                            </div>

                            <div className="grid gap-4 md:grid-cols-1 lg:grid-cols-2">
                                {lessonDetail?.prerequisite_list?.beside_requirement.map((item) => (
                                    <PrerequisiteCard key={item.id} item={item} type="beside"/>
                                ))}
                            </div>
                        </div>
                    )}


                </div>
            </div>


        </>
    );
}

export default LessonRequirementSection;
